import React from 'react';

import Container from '@mui/material/Container';
import Box from '@mui/material/Box'

import {awsConfig} from '../../shared/config';

function Status(props) {

    return(
        <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>
                I am Status!
                <br/>
                <br/>
                Environment (NODE_ENV): {process.env.NODE_ENV}
                <br/>
                Config Env: {process.env.REACT_APP_ENV}
                <br/>
                Config API: {process.env.REACT_APP_API_URL}
                <br/>
                Invoke URL: {awsConfig.api.invokeUrl}
                <br/>
                <br/>
            </Box>
        </Container>
    );

}

export default Status;